module.exports = __webpack_public_path__ + "img/eye-hover.5ab5cf34.svg";